import "../views/object_view"
import BasicObject from "../core/basic_object"

export default class Controller extends BasicObject {}
